import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ViewCoupon = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state && location.state.data;
  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }

  console.log("dsadada", data);

  return (
    <div className="flex gap-8">
      <div style={styles.container} className="min-h-[37rem]">
        <table style={styles.table}>
          <tbody>
            <div
              className="flex cursor-pointer items-center gap-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MdOutlineArrowBack
                className="cursor-pointer"
                style={{ fontSize: "17px" }}
              />
              <p>{t("Back")}</p>
            </div>
            <p className="mb-4 text-center text-[20px] font-semibold">
              {t("View Coupen")}
            </p>
            <hr className="mb-4" />
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Coupon Code")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.coupon_code}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Title")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.coupon_title}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Discount")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.coupon_discount}
                </td>
              </tr>
            </div>

            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Created Date")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {moment.unix(data?.created_at).format("DD/MM/YYYY")}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Start Date")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {moment.unix(data?.coupon_start_date).format("DD/MM/YYYY")}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Expiry Date")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {moment.unix(data?.coupon_expiry_date).format("DD/MM/YYYY")}
                </td>
              </tr>
            </div>

            {/* <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Membership plan")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  <p>
                    {" "}
                    {data?.discounted_plan_info?.map((plan) => (
                      <p> {plan?.plan_title}</p>
                    ))}
                  </p>
                </td>
              </tr>
            </div> */}

            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] pb-[7px] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Membership plan")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {" "}
                  {data?.discounted_plan_info?.map((plan) => (
                    <p> {plan?.plan_title}</p>
                  ))}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Coupon Type")}
                </td>

                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.coupon_type}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td className="font-lighht w-[12rem] text-[14px] font-bold" style={styles.label}></td>
                <td className="w-[12rem] pl-4 text-[14px] "></td>
              </tr>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  );
};
const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};

export default ViewCoupon;
